import { render, staticRenderFns } from "./Look.vue?vue&type=template&id=b86b3764&scoped=true"
import script from "./Look.vue?vue&type=script&lang=js"
export * from "./Look.vue?vue&type=script&lang=js"
import style0 from "./Look.vue?vue&type=style&index=0&id=b86b3764&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b86b3764",
  null
  
)

export default component.exports